import { render, staticRenderFns } from "./Pm25Chart.vue?vue&type=template&id=08bf71c9&"
import script from "./Pm25Chart.vue?vue&type=script&lang=js&"
export * from "./Pm25Chart.vue?vue&type=script&lang=js&"
import style0 from "./Pm25Chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports